import { Box, Button, HStack, Text } from '@chakra-ui/react'
import { AlertTriangle, CreditCard, X } from 'lucide-react'
import { useState } from 'react'

interface UpgradeBannerProps {
  reason: 'limit_reached' | 'feature_unavailable' | 'payment_failed' | 'subscription_canceled'
  resource?: 'residences' | 'users' | 'lots'
  featureName?: string
  onDismiss?: () => void
}

export function UpgradeBanner({ reason, resource, featureName, onDismiss }: UpgradeBannerProps) {
  const [isVisible, setIsVisible] = useState(true)

  if (!isVisible) return null

  const getMessage = () => {
    switch (reason) {
      case 'limit_reached':
        return `Vous avez atteint la limite de ${resource} de votre formule actuelle.`
      case 'feature_unavailable':
        return `La fonctionnalité "${featureName}" n'est pas disponible dans votre formule actuelle.`
      case 'payment_failed':
        return `Votre dernier paiement a échoué. Veuillez mettre à jour vos informations de paiement.`
      case 'subscription_canceled':
        return `Votre abonnement a été annulé. Réactivez-le pour continuer à utiliser Kopro.`
      default:
        return `Mettez à niveau votre abonnement pour continuer.`
    }
  }

  const getActionText = () => {
    if (reason === 'payment_failed') return 'Mettre à jour le paiement'
    if (reason === 'subscription_canceled') return 'Réactiver l\'abonnement'
    return 'Voir les formules'
  }

  const handleAction = () => {
    if (reason === 'payment_failed' || reason === 'subscription_canceled') {
      // Redirect vers portail Stripe
      window.open('https://billing.stripe.com/p/login/test_5kQ14pb8Bh1Ob5X7N55os00', '_blank')
    } else {
      // Redirect vers landing pricing
      window.location.href = '/#pricing'
    }
  }

  const handleDismiss = () => {
    setIsVisible(false)
    onDismiss?.()
  }

  return (
    <Box position="sticky" top={0} zIndex={1000} bg="orange.500" color="white" py={3} px={6}>
      <HStack justify="space-between" maxW="container.xl" mx="auto">
        <HStack gap={3}>
          <AlertTriangle size={20} />
          <Text fontWeight="medium">{getMessage()}</Text>
        </HStack>

        <HStack gap={2}>
          <Button
            size="sm"
            variant="solid"
            bg="white"
            color="orange.600"
            _hover={{ bg: 'orange.50' }}
            onClick={handleAction}
          >
            <CreditCard size={16} />
            {getActionText()}
          </Button>
          <Button size="sm" variant="ghost" color="white" onClick={handleDismiss}>
            <X size={16} />
          </Button>
        </HStack>
      </HStack>
    </Box>
  )
}
